export default __webpack_public_path__ + "static/media/Delete.c973a368.svg";